import { Typography } from "antd";
import dayjs from "dayjs";

import { getOrderPaidAt } from "@fitness-app/data-models/entities/Order";

/** Formats `getOrderPaidAt` for a table cell; the rule of what counts as paid lives there. */
export const OrderPaidAtCell = ({ order }: { order: Parameters<typeof getOrderPaidAt>[0] }) => {
  const paidAt = getOrderPaidAt(order);

  if (!paidAt) {
    return <Typography.Text type="secondary">—</Typography.Text>;
  }

  return <span className="whitespace-nowrap">{dayjs(paidAt).format("DD.MM.YYYY HH:mm")}</span>;
};
